<template>
  <section class="dashboard-adventures mb-64">
    <h3 class="text-h4">Activity-based care at home</h3>
    <p class="text-body">Book a sitter to bring a fun & enriching Adventure based on your child's interests</p>

    <div class="flex gap-16 overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24 pt-16 max-w-screen">
      <ComplexCard
        v-for="(adventure, index) in adventuresList"
        :key="index"
        class="min-w-[212px]"
        variant="small"
        :headerImageUrl="adventure.adventureCategoryImage && adventure.adventureCategoryImage.url"
        :title="adventure.title"
        :firstLineText="firstLineText(adventure.ageRangeText)"
        :minPayRate="adventure.minPayRate"
        :maxPayRate="adventure.maxPayRate"
        :detailsUrl="adventureDetailsUrl(adventure.sitterLocation, adventure.id)"
      />
    </div>

    <Button
      v-if="zipcode"
      class="p-0"
      variant="text"
      :href="adventureLinkUrl"
      value="More adventures"
      ariaLabel="Activity-based care at home"
    />
  </section>
</template>

<script lang="ts">
import Button from '../../../components/button/Button.vue';
import ComplexCard from '../../../components/complex_card/ComplexCard.vue';
import adventures from '@/lib/adventures';

export default {
  name: 'NearbyAdventuresList',
  components: {
    Button,
    ComplexCard,
  },
  props: {
    adventures: {
      default: () => [],
      type: Array,
    },
    city: {
      default: '',
      type: String,
    },
    zipcode: {
      default: '',
      type: String,
    },
  },
  computed: {
    adventuresList(): Array<any> {
      return this.adventures.map((adventure: any) => adventure?.node?.adventure);
    },
    adventureLinkUrl(): string {
      return `/adventures/search?zipcode=${this.zipcode}`;
    },
  },
  methods: {
    adventureDetailsUrl(adventureLocation, adventureId): string | null {
      return adventures.getAdventureDetailsUrl(adventureLocation, adventureId);
    },
    firstLineText(adventureCategory, ageRange): string | null {
      return adventures.getFirstLineText('small', adventureCategory, ageRange);
    },
  },
};
</script>
